import React, { useState } from "react";
import Skeleton from "react-loading-skeleton";

const ImageSkeletonComponent = ({
  src,
  alt,
  imageClassname,
}: {
  src: string;
  alt: string;
  imageClassname: string;
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const skeletonImageClassName = `${isLoading ? "h-0" : imageClassname}`;

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  return (
    <>
      {isLoading && (
        <Skeleton className=" relative -top-2 h-full" baseColor="#e6f1fc" />
      )}
      <img
        src={src}
        alt={alt}
        onLoad={handleImageLoad}
        className={skeletonImageClassName}
      />
    </>
  );
};

export default ImageSkeletonComponent;
